export default __webpack_public_path__ + "fffa04fa1cc495383c1ba2acebf393df.chrome.png";